<template>
    <v-app :style="customCss">
        <CookieDisclaimer v-if="isCookieDisclaimerReady"/>
        <!-- Global GTM tracker -->
        <GoogleAnalyticsTracker
            v-if="availableTrackings.google"
            :additionnalGTM="promoterId ? promoterGTMList[promoterId] : null"
        />

        <HabiteoTracker v-if="availableTrackings.habiteo"/>
        <PromoterCustomization v-if="hasPromoterCustomization"/>
        <router-view/>
    </v-app>
</template>

<script>
    import Http from '@/api/data';
    import { EventBus } from '@/event-bus';
    import { mapActions, mapGetters } from 'vuex';

    import CookieDisclaimer from '@/components/gdpr/CookieDisclaimer';
    import GoogleAnalyticsTracker from '@/components/gdpr/components/GoogleAnalyticsTracker';
    import HabiteoTracker from '@/components/gdpr/components/HabiteoTracker';
    import PromoterCustomization from '@/components/PromoterCustomization';

    export default {
        name: 'App',
        components: {
            CookieDisclaimer,
            GoogleAnalyticsTracker,
            HabiteoTracker,
            PromoterCustomization
        },
        data: () => {
            return {
                customCss: null,
                hasPromoterCustomization: true,
                isCookieDisclaimerReady: false,
                promoterGTMList: {
                    '5xL2PqkphAUrFohtW2p4uq': 'GTM-KHR8C7G' // AEDAS
                }
            };
        },
        computed: {
            ...mapGetters([
                'availableTrackings',
                'isReviewUse'
            ]),
            promoterId() {
                return this.$route.query.key ? this.$route.query.key : null;
            }
        },
        created() {
            // Save in store : protocol used by user
            let url = new URL(window.location.href);
            let protocol = `${url.protocol}//`;

            this.setProtocol(protocol);
            this.setNetworkStatus(navigator.onLine);
            this.checkLocalstorage();

            // Save in store : iframe use
            this.setIframeStatus();

            // Save in store : internal mode
            if (this.isReviewUse)
                this.setInternalStatus(true);
            else {
                let urlLink = `${protocol}${process.env.API_LIST.FO}/check-internal`;
                Http.getData(urlLink).then(payload => {
                    if (payload) {
                        if (payload.isInternal)
                            this.setInternalStatus(true);
                        this.isCookieDisclaimerReady = true;
                    }
                });
            }
            
        },
        mounted() {
            EventBus.$on('setCustomCss', promoterCss => {
                this.customCss = promoterCss
            });
        },
        methods: {
            ...mapActions([
                'checkGPDRConsent',
                'setNetworkStatus',
                'checkLocalstorage',
                'setIframeStatus',
                'setInternalStatus',
                'setNetworkStatus',
                'setProtocol'
            ])
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/_common.scss";
</style>


// WEBPACK FOOTER //
// src/App.vue